import { IDropdownOption } from '@fluentui/react';

type DRIItemType = 'link' | 'text' | 'script' | 'kusto' | 'sql';

export const defaultIconForType = (itemType: DRIItemType): string => {
    switch (itemType) {
        case 'link':
            return 'Link';
        case 'text':
            return 'TextDocument';
        case 'script':
            return 'CommandPrompt';
        case 'kusto':
            return 'Database';
        case 'sql':
            return 'TableComputed';
        default:
            return 'Page';
    }
};

export const itemTypeOptions: IDropdownOption[] = [
    { key: 'link', text: 'Link' },
    { key: 'text', text: 'Text' },
    { key: 'script', text: 'PowerShell Script' },
    { key: 'kusto', text: 'Kusto Query' },
    { key: 'sql', text: 'SQL Query' },
];
